import { isUndefined } from 'lodash';

import { ProgressContextProps } from '../contexts/ProgressContext';

type Params = {
    index: ProgressContextProps['pageIndex'];
    numberOfPages: number;
};

export const getValidPageIndex = ({ index, numberOfPages }: Params): number => {
    if (isUndefined(index)) return 0;
    const isValid = Boolean(index >= -1 && index < numberOfPages);
    if (!isValid) return 0;
    if (index === -1) return numberOfPages - 1;
    return index;
};
